
import {Component, Vue} from "vue-property-decorator";
import {doDownload} from "@/utils/oss-download";
import {
  createCustomerTransactionStatisticsReport,
  createInStorageStatisticsOfPackingListStatisticsReport, createPartDeliveryPackingListAmountStatisticsReport,
  customerShipmentStatistics,
  delayedShippingStatistics,
  exportBookingOrderStateReport,
  exportContainerTypeStatisticsExcel,
  exportCostDetails,
  exportCustomersProductInfos,
  exportDeclarationAmountDetailsFinances,
  exportDeclarationAmountDetailsForLogistics,
  exportDeclarationFee,
  exportDeclarationWorkLoadStatisticsExcel,
  exportDeliveryNoteAndPackingList,
  exportFinancial,
  exportHenganLoadingPlanTransship,
  exportinventoryCommodityShipmentDetails,
  exportWarehouseEntryFeeStatisticsReport,
  factoryShipmentStatistics,
  getReport,
  getReportOssUrl,
  productShipmentStatistics
} from "@/api/report";
import {searchCustomer} from "@/api/customer";
import {ICustomerModel} from "@/api/types";

@Component({
  name: "reportDetails",
})
export default class extends Vue {
  private showReportDialog = false;
  private one = false;
  private two = false;
  private three = false;
  private four = false;
  private five = false;
  private six = false;
  private seven = false;
  private eight = false;
  private nine = false;
  private ten = false;
  private eleven = false;
  private tweleve = false;
  private thirteen = false;
  private fourteen = false;
  private fifteen = false;
  private sixteen = false;
  private seventeen = false;
  private eighteen = false;
  private nineteen = false;
  private twenty = false;

  private listQuery = {
    date: "2022-5",
    fileDate: null,
    startDate: null,
    endDate: null,
    customerCode: null,
    customerAbbreviation: null,
    bookingOrderCode: null,
    description: null,
    hqPackingListCode: null,
    dateRange: null,
    abbreviation: null,
    customerId: null,
    factoryName: null,
    deferredDays: null,
  };

  private rules = {
    deferredDays: [{required: true, message: "请输入延期天数", trigger: "blur"}],
  };

  private pickerOptions = {
    onPick: this.getPickDate,
    disabledDate: this.disabledDate,
  }

  private pickDate = ''

  private data: Reports[] = [];

  private getDate() {
    const date = new Date();
    let yy = date.getFullYear();
    let MM = date.getMonth() + 1;
    let dd = date.getDate();
    let HH = date.getHours();
    let mm = date.getMinutes();
    let ss = date.getSeconds();
    return yy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
  }

  private async createFinancialReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.two = true;
    await exportFinancial(this.listQuery).then(res => {
      this.two = false;
    }).catch(err => {
      console.log(err);
      this.two = false;
    });
  }


  private async createHenganLoadingPlanTransshipReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择出库日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.five = true;
    await exportHenganLoadingPlanTransship(this.listQuery).then(res => {
      this.five = false;
    }).catch(err => {
      console.log(err);
      this.five = true;
    });
  }

  private exportinventoryCommodityShipmentDetails() {
    this.$confirm("库存商品统计表待OMS开发完善", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        if (this.listQuery.dateRange) {
          this.listQuery.startDate = this.listQuery.dateRange[0];
          this.listQuery.endDate = this.listQuery.dateRange[1];
        } else {
          this.$notify({
            title: "提示",
            message: "请选择创建日期！",
            type: "error",
            duration: 2000
          });
          return
        }
        this.listQuery.fileDate = this.getDate();
        this.successMessage();
        this.six = true;
        exportinventoryCommodityShipmentDetails(this.listQuery).then(res => {
          this.six = false;
        }).catch(err => {
          console.log(err);
          this.six = false;
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private getPickDate(pick) {
    this.pickDate = pick
  }
  private disabledDate(date) {
    const { minDate, maxDate } = this.pickDate as any
    if (minDate && !maxDate) {
      const diff = Math.abs(minDate.valueOf() - date.valueOf())
      // 日期选择范围不能大于一年
      if (diff > 1000 * 3600 * 24 * 365) {
        return true
      }
    }
  }
  private pickerBlur(val) {
    this.pickDate = '' // 清空getPickDate获取的数据
  }


  private async exportDeclarationAmountDetailsForLogistics() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.seven = true;
    await exportDeclarationAmountDetailsForLogistics(this.listQuery).then(res => {
      this.seven = false;
    }).catch(err => {
      console.log(err);
      this.seven = false;
    });
  }

  private async exportDeclarationWorkLoadStatisticsExcel() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.eight = true;
    await exportDeclarationWorkLoadStatisticsExcel(this.listQuery).then(res => {
      this.eight = false;
    }).catch(err => {
      console.log(err);
      this.eight = false;
    });
  }

  private async exportDeliveryNoteAndPackingList() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.nine = true;
    await exportDeliveryNoteAndPackingList(this.listQuery).then(res => {
      this.nine = false;
    }).catch(err => {
      console.log(err);
      this.nine = false;
    });
  }

  private async exportContainerTypeStatistics() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.ten = true;
    await exportContainerTypeStatisticsExcel(this.listQuery).then(res => {
      this.ten = false;
    }).catch(err => {
      console.log(err);
      this.ten = false;
    });
  }

  private async customerShipmentStatistics() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.eleven = true;
    await customerShipmentStatistics(this.listQuery).then(res => {
      this.eleven = false;
    }).catch(err => {
      console.log(err);
      this.eleven = false;
    });
  }

  private async exportWarehouseEntryFeeStatisticsReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.tweleve = true;
    await exportWarehouseEntryFeeStatisticsReport(this.listQuery).then(res => {
      this.tweleve = false;
    }).catch(err => {
      console.log(err);
      this.tweleve = false;
    });
  }


  private async productShipmentStatistics() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.thirteen = true;
    await productShipmentStatistics(this.listQuery).then(res => {
      this.thirteen = false;
    }).catch(err => {
      console.log(err);
      this.thirteen = false;
    });
  }

  private async exportDeclarationFee() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择付款日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.fourteen = true;
    await exportDeclarationFee(this.listQuery).then(res => {
      this.fourteen = false;
    }).catch(err => {
      console.log(err);
      this.fourteen = false;
    });
  }

  private async exportBookingOrderStateReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.fifteen = true;
    await exportBookingOrderStateReport(this.listQuery).then(res => {
      this.fifteen = false;
    }).catch(err => {
      console.log(err);
      this.fifteen = false;
    });
  }

  private async factoryShipmentStatistics() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.sixteen = true;
    await factoryShipmentStatistics(this.listQuery).then(res => {
      this.sixteen = false;
    }).catch(err => {
      console.log(err);
      this.sixteen = false;
    });
  }

  private async createCustomerTransactionStatisticsReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.seventeen = true;
    await createCustomerTransactionStatisticsReport(this.listQuery).then(res => {
      this.seventeen = false;
    }).catch(err => {
      console.log(err);
      this.seventeen = false;
    });
  }
  private async createInStoragePackingListReport() {
    this.successMessage();
    this.nineteen = true;
    await createInStorageStatisticsOfPackingListStatisticsReport().then(res => {
      this.nineteen = false;
    }).catch(err => {
      console.log(err);
      this.nineteen = false;
    });
  }

  private async delayedShippingStatistics() {
    // if (this.listQuery.dateRange) {
    //   this.listQuery.startDate = this.listQuery.dateRange[0];
    //   this.listQuery.endDate = this.listQuery.dateRange[1];
    // } else {
    //   this.$notify({
    //     title: "提示",
    //     message: "请选择创建日期！",
    //     type: "error",
    //     duration: 2000
    //   });
    //   return
    // }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.eighteen = true;
    await delayedShippingStatistics(this.listQuery).then(res => {
      this.eighteen = false;
    }).catch(err => {
      console.log(err);
      this.eighteen = false;
    });
  }

  private async createPartDeliveryPackingListAmountReport() {
    this.successMessage();
    this.twenty = true;
    await createPartDeliveryPackingListAmountStatisticsReport().then(res => {
      this.twenty = false;
    }).catch(err => {
      console.log(err);
      this.twenty = false;
    });
  }



  private async createCustomersProductInfosReport() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.one = true;
    await exportCustomersProductInfos(this.listQuery).then(res => {
      this.one = false;
    }).catch(err => {
      console.log(err);
      this.one = false;
    });
  }

  private async createCostDetails() {
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.three = true;
    await exportCostDetails(this.listQuery).then(res => {
      this.three = false;
    }).catch(err => {
      console.log(err);
      this.three = false;
    });
  }

  private async createDeclarationAmountDetailsFinances() {
    if (this.listQuery.dateRange) {
      this.listQuery.startDate = this.listQuery.dateRange[0];
      this.listQuery.endDate = this.listQuery.dateRange[1];
    } else {
      this.$notify({
        title: "提示",
        message: "请选择创建日期！",
        type: "error",
        duration: 2000
      });
      return
    }
    this.listQuery.fileDate = this.getDate();
    this.successMessage();
    this.four = true;
    await exportDeclarationAmountDetailsFinances(this.listQuery).then(res => {
      this.four = false;
    }).catch(err => {
      console.log(err);
      this.four = false;
    });
  }

  private async downloadOssReport(row) {
    const ossUrl:any = await getReportOssUrl(row.ossUrl);
    doDownload(ossUrl);
  }

  private successMessage() {
    this.$notify({
      title: "提示",
      message: "报表生成中，请留意下载列表！",
      type: "warning",
      duration: 2000
    });
  }

  private async showDialog(type: string) {
    this.showReportDialog = true;
    const data_: any = await getReport({type: type});
    this.data = data_;
  }

  private isSearchingCustomers = false;
  private customers: ICustomerModel[] = [];

  private searchCustomers(a) {
    this.isSearchingCustomers = true;
    searchCustomer({ keyword: a })
        .then((res: any) => {
          this.customers = res;
          this.isSearchingCustomers = false;
        })
        .catch(() => {
          this.isSearchingCustomers = false;
        });
  }
}

class Reports {
  id: string;
  fileName: string;
  ossUrl: string;
  date: string;
}
